import { render, staticRenderFns } from "./LayoutConfig.vue?vue&type=template&id=5bc72220"
import script from "./LayoutConfig.vue?vue&type=script&lang=js"
export * from "./LayoutConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports